import React, { useState } from "react";
import "../css/Contact.css";
import assets from '../assets/images';

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    telephone: "",
    event: "",
    package: "premium",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const validateEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const validatePhone = (phone) => {
    return /^[0-9]{10}$/.test(phone);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!formData.firstName || !formData.lastName || !formData.email || !formData.telephone || !formData.event || !formData.package) {
      alert("Please fill all required fields!");
      return;
    }
  
    if (!validateEmail(formData.email)) {
      alert("Please enter a valid email address.");
      return;
    }
  
    if (!validatePhone(formData.telephone)) {
      alert("Please enter a valid 10-digit phone number.");
      return;
    }
  
    try {
      const response = await fetch("https://priyanthabandara.lk/send-email.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: new URLSearchParams({
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          telephone: formData.telephone,
          event: formData.event,
          package: formData.package,
          message: formData.message,
        }).toString(),
      });
      
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const result = await response.json();
  
      if (result.success) {
        alert("Your message has been sent successfully!");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          telephone: "",
          event: "",
          package: "premium",
          message: "",
        });
      } else {
        throw new Error(result.message || "Failed to send message");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Error: " + error.message);
    }
  };
  

  return (
    <div className="contactbody">
      {/* Map at the top */}
      <div className="map-top">
        <iframe
          title="Our Studio Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3961.7400900052176!2d79.91805077475588!3d6.801441393195965!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae24ff64820ee8f%3A0xfb07d1dc6118c32a!2s96%20Moratuwa%20-%20Piliyandala%20Rd%2C%20Piliyandala!5e0!3m2!1sen!2slk!4v1727517881058!5m2!1sen!2slk"
          width="100%"
          height="450"
          loading="lazy"
          allowFullScreen
        ></iframe>
      </div>

      {/* Section with background */}
      <div className="contact-background">
      <div className="vision-text cont-h2">
          <h2>Contact Us</h2>
          <div className="title-vis-line">
        <span className="vis-dot"></span>
        <span className="vis-line"></span>
        <span className="vis-dot"></span>
      </div>
          <p className="vis-para cont-des">
          At Priyantha Bandara Photography, we are dedicated to capturing your most precious moments with creativity and passion. Whether you’re planning a wedding, a special event, or a professional photoshoot, we would love to be part of your journey.<br/>

Have a question about our services? Need to discuss a custom photography package? We’re here to help! Reach out to us via phone, email, or visit our studio to explore how we can turn your vision into stunning images. You can also fill out our contact form to share your details, and we’ll get back to you as soon as possible.<br/>

We believe in building lasting relationships with our clients, ensuring a smooth and enjoyable photography experience. Let’s create something unforgettable together—contact us today!
          </p>
        </div>
      <div className="contact-buttons">
  <a href="tel:0714313131" className="contact-btn">
    Call Us:<br/>
    0714 31 31 31
  </a>
  <a href="mailto:info@priyanthabandara.lk" className="contact-btn">
    Email Us: 
    info@priyanthabandara.lk
  </a>
</div>


        {/* Inquiry Form */}
        <div className="contact-form">
          <h2>Send Us an Inquiry</h2>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <div className="input-field">
                <label htmlFor="firstName">First Name</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  placeholder="First Name"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="input-field">
                <label htmlFor="lastName">Last Name</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  placeholder="Last Name"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="input-field">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="input-field">
              <label htmlFor="telephone">Telephone</label>
              <input
                type="tel"
                id="telephone"
                name="telephone"
                placeholder="Telephone"
                value={formData.telephone}
                onChange={handleChange}
                required
              />
            </div>

            <div className="input-field">
              <label htmlFor="event">Event</label>
              <select
                id="event"
                name="event"
                value={formData.event}
                onChange={handleChange}
                required
              >
                <option value="">Select an Event</option>
                <option value="wedding">Wedding</option>
                <option value="event">Event</option>
                <option value="concert">Concert</option>
                <option value="portraits">Portraits</option>
              </select>
            </div>

            <div className="input-field">
              <label>Package</label>
              <div className="radio-group">
                <label>
                  <input
                    type="radio"
                    name="package"
                    value="premium"
                    checked={formData.package === "premium"}
                    onChange={handleChange}
                  /> Premium
                </label>
                <label>
                  <input
                    type="radio"
                    name="package"
                    value="standard"
                    checked={formData.package === "standard"}
                    onChange={handleChange}
                  /> Standard
                </label>
                <label>
                  <input
                    type="radio"
                    name="package"
                    value="basic"
                    checked={formData.package === "basic"}
                    onChange={handleChange}
                  /> Basic
                </label>
              </div>
            </div>

            <div className="input-field">
              <label htmlFor="message">Your Message</label>
              <textarea
                id="message"
                name="message"
                placeholder="Your Message"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <button className="con-us-btn" type="submit">Submit</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
